import { Icon, SPACING } from "@bridgesplit/ui";
import { AllInclusiveOutlined, LockOutlined, PieChartOutline, SavingsRounded } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import { getFeatureFlag, Hidable } from "@bridgesplit/utils";
import {
    PORTFOLIO_OVERVIEW_SLUG,
    POINTS_SLUG,
    LOOPS_SLUG,
    BORROW_SLUG,
    LEND_SLUG,
    EARN_SLUG,
    COPY,
    ECOSYSTEM_SLUG,
    LOCKBOX_SLUG
} from "app/constants";
import { useLockboxAccess, useLoopscaleWalletContext } from "@bridgesplit/abf-react";

import { NavOption } from "./types";
import { DESKTOP_PADDING, NAV_BREAKPOINT } from "./constants";

export function useNavOptions(params?: { isMobile?: boolean }) {
    const {
        data: { userWalletAddress: activeWallet }
    } = useLoopscaleWalletContext();
    const { data: lockboxAccess } = useLockboxAccess({
        skip: !activeWallet || !getFeatureFlag("lockbox")
    });
    const options: Hidable<NavOption>[] = [
        {
            title: "Lend",
            path: LEND_SLUG,
            icon: <Icon type="lend" />
        },
        {
            title: COPY.EARN_TERM,
            path: EARN_SLUG,
            icon: <SavingsRounded />
        },
        {
            title: "Loop",
            path: LOOPS_SLUG,
            icon: <AllInclusiveOutlined />,
            pathRegex: new RegExp(LOOPS_SLUG)
        },
        {
            title: "Borrow",
            path: BORROW_SLUG,
            icon: <Icon type="borrow" />
        },
        {
            title: "Portfolio",
            path: PORTFOLIO_OVERVIEW_SLUG,
            icon: <PieChartOutline />,
            hide: !activeWallet
        },
        {
            title: COPY.POINTS_TERM,
            path: POINTS_SLUG,
            icon: <Icon type="points" />,
            hide: true
        },
        {
            title: "Ecosystem",
            path: ECOSYSTEM_SLUG,
            icon: <Icon type="globe" />
        },
        {
            title: "Lockbox",
            path: LOCKBOX_SLUG,
            icon: <LockOutlined />,
            hide: !getFeatureFlag("lockbox") || !activeWallet || !lockboxAccess?.allowed
        }
    ].filter((o) => !o.hide);

    return options;
}

export function useNavbarHeight() {
    const isMobile = useMediaQuery(NAV_BREAKPOINT.below);
    const height = 70;
    const navFooter = 0;
    const footer = isMobile ? 0 : 40;

    return {
        footer,
        height,
        navFooter,
        heightInPixels: `${height}px`,
        fullHeight: `calc(100vh - ${height}px)`,
        stickyTop: height + DESKTOP_PADDING * SPACING
    };
}
